import * as Animate from "react-reveal";
import { Link } from "react-router-dom";

const StoryCtaSection = () => {
  return (
    <section className="px-4">
      <Animate.Fade bottom>
        <div
          className="bg-primary text-white rounded-[25px] flex flex-col sm:flex-row justify-between items-start sm:items-center gap-8 sm:gap-12 relative overflow-hidden mx-auto"
          style={{
            maxWidth: "1228px",
            minHeight: "245px",
            marginBottom: "88px",
            padding: "35px 44px",
          }}
        >
          <span
            className="absolute font-extrabold pointer-events-none hidden md:block"
            style={{
              color: "rgba(255,255,255,0.07)",
              letterSpacing: "-0.075em",
              fontSize: "115px",
              bottom: "-42px",
              right: "-16px",
            }}
            aria-hidden="true"
          >
            STORIES
          </span>
          <div className="relative z-[1]">
            <p className="text-secondary tracking-[0.1em] uppercase text-[15px] font-extrabold mb-[9px]">
              Your Story Can Start With One Project
            </p>
            <h2
              className="tracking-[-0.047em] max-w-[740px] m-0"
              style={{ fontSize: "clamp(31px, 3.6vw, 47px)", lineHeight: 1.18 }}
            >
              Find the programme that gives you something real to build.
            </h2>
          </div>
          <Link
            to="/start"
            className="relative z-[1] bg-secondary text-primary rounded-[11px] inline-flex items-center gap-[10px] text-[15px] font-extrabold px-[19px] shrink-0"
            style={{ minHeight: "53px" }}
          >
            Explore Utiva programmes <span aria-hidden="true">→</span>
          </Link>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default StoryCtaSection;
